var m = require('mithril');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var animations = require('../../libs/animations');
var formGroup = require('../../components/formGroup');
var ToggleSwitch = require('../../components/toggleSwitch');
var fetchChannelConfigModal = require('../fetchChannelConfigModal');

var host = Object.create(Model);
  
host.name = 'CNIP Server';
host.url = 'lontalkcnip';
host['@class'] = 'LontalkCnip';
host.childLabel = 'Networks';
host.actions = [
  {
    name: 'Discover',
    func: function (ctrl) {
      return loaders.requestWithLoader({
        url: ctrl.record['@id'] + '/sync/',
        method: "GET",
        loader: 'submit'
      })
      .then(function (res) {
        return ctrl.init();
      })
      .catch(function (e) {
        alert(JSON.stringify(e.response.cause));
      })
    }
  },
  {
    name: 'Fetch Channel Config',
    func: function (ctrl) {
      return fetchChannelConfigModal.open(ctrl.record, ctrl.init);
    }
  }
];
host.fields = {
  name: {
    type: 'string',
    default: '',
    validators: {
      presence : true, 
      length: {minimum: 3, maximum: 128, default: ''},
    }
  },
  host: {
    type: 'string',
    default: '127.0.0.1',
    validators: {
      presence: true,
    }
  },
  port: {
    type: 'number',
    default: 1629,
    validators: {
      presence: true,
      numericality: {
        onlyInteger: true,
        greaterThan: 0,
        lessThanOrEqualTo: 65535
      }
    }
  },
  ipUnicastAddress: {
    type: 'string',
    default: '127.0.0.1',
    validators: {
      presence: true,
    }
  },
  ipUnicastPort: {
    type: 'number',
    default: 1628,
    validators: {
      presence: true,
      numericality: {
        onlyInteger: true,
        greaterThan: 0,
        lessThanOrEqualTo: 65535
      }
    }
  },
  eesHost: {
    validators: {}
  },
  eesUser: {
    validators: {}
  },
  eesPass: {
    validators: {}
  },
  lastSync: {
    type: 'string',
    validators: {}
  },
  error: {},
  enabled: {
    type: 'switch',
    default: 1,
  }
};

host.initForm();

function isEnabled(value) {
  if (value === true || value === 1) return true;
  if (typeof value === 'string') {
    var normalized = value.trim().toLowerCase();
    return normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on';
  }
  return false;
}

function enabledField(enabled) {
  return m(formGroup, [
    m('div.flex.items-center.justify-between', [
      m('label', {for:'enabled-input'}, 'Enabled'),
      m(ToggleSwitch, {
        id: 'enabled-input',
        size: 'modal',
        checked: enabled,
        ariaLabel: 'Enabled',
        onchange: function () { host.form.enabled(enabled ? 0 : 1); }
      })
    ])
  ]);
}

host.view = function () { 
  var enabled = isEnabled(host.form.enabled());

  return  m('form', {role:'form'}, [
    host.errorView(),
    enabledField(enabled),
    m(formGroup, [
      m('label', {for:'host-name-input'}, 'Name'),
      m('input.form-control', {
        id:'host-name-input', 
        autocomplete: 'off',
        type:'text', 
        oninput: function(ev){host.form.name(ev.target.value)},
        value: host.form.name(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'host-host-input'}, 'Config Server URI'),
      m('input.form-control', {
        id:'host-host-input', 
        autocomplete: 'off',
        type:'text', 
        oninput: function(ev){host.form.host(ev.target.value)},
        value: host.form.host(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'host-port-input'}, 'Port'),
      m('input.form-control', {
        id:'host-port-input', 
        autocomplete: 'off',
        type:'text', 
        oninput: function(ev){host.form.port(ev.target.value)},
        value: host.form.port(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'unicast-input'}, 'Unicast URI'),
      m('input.form-control', {
        id:'unicast-input', 
        autocomplete: 'off',
        type:'text', 
        oninput: function(ev){host.form.ipUnicastAddress(ev.target.value)},
        value: host.form.ipUnicastAddress(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'host-unicast-port-input'}, 'Unicast Port'),
      m('input.form-control', {
        id:'host-unicast-port-input', 
        autocomplete: 'off',
        type:'number', 
        oninput: function(ev){host.form.ipUnicastPort(ev.target.value)},
        value: host.form.ipUnicastPort(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'eesPath-input'}, 'EES Host'),
      m('input.form-control', {
        id:'eesPath-input', 
        autocomplete: 'off',
        type:'text', 
        oninput: function(ev){host.form.eesHost(ev.target.value)},
        value: host.form.eesHost(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'eesPath-input'}, 'EES User'),
      m('input.form-control', {
        id:'eesPath-input', 
        autocomplete: 'off',
        type:'text', 
        oninput: function(ev){host.form.eesUser(ev.target.value)},
        value: host.form.eesUser(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'eesPath-input'}, 'EES Pass'),
      m('input.form-control', {
        id:'eesPath-input', 
        autocomplete: 'off',
        type:'password', 
        oninput: function(ev){host.form.eesPass(ev.target.value)},
        value: host.form.eesPass(),
      })
    ])
  ])
}

module.exports = host;
